import React, { Component } from 'react';
import NavBar from './components/NavBar/NavBar';
import Header from './components/Header/Header';
import Body from './components/Body/Body';
import Footer from './components/Footer/Footer';
import SmoothScroll from './components/SmoothScroll';

class App extends Component {
  render() {
    return (
      <div className="App">
        <NavBar />
        <Header />
        <Body />
        <Footer />
        <SmoothScroll />
      </div>
    );
  }
}

export default App;
